import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

import styles from './TryBuyPopup.scss';

import { CustomDialog } from '../../Core/Components/CustomDialog/CustomDialog';

const TryBuyPopupBase = ({ isOpen, onClose, pastExpirationDate }) => {
  return (
    <CustomDialog
      isOpen={isOpen}
      primaryBtnContent={null}
      secondaryBtnContent={
        pastExpirationDate ? null : (
          <div style={{ textTransform: 'none' }}>Close</div>
        )
      }
      secondaryBtnProps={{ variant: 'text' }}
      onSecondaryBtnClick={onClose}
      shouldShowCloseIcon={false}
      onClose={onClose}
      customClasses={{
        dialog_paper: pastExpirationDate
          ? styles.tryBuy_dialog_paper_past_expiration
          : styles.tryBuy_dialog_paper,
        content_container: pastExpirationDate
          ? styles.tryBuy_dialog_content_past_expiration
          : '',
      }}
    >
      {' '}
      <div>
        <div
          className={
            pastExpirationDate
              ? styles.tryBuy_dialog_header_past_expiration
              : styles.tryBuy_dialog_header
          }
        >
          {pastExpirationDate ? 'Trial is over.' : 'Not available in trial'}{' '}
        </div>
        <div style={{ fontSize: pastExpirationDate ? 15 : 13 }}>
          {pastExpirationDate
            ? 'Please get in touch with our team.'
            : 'Please upgrade to the full version to view this.'}
        </div>
      </div>
    </CustomDialog>
  );
};

TryBuyPopupBase.defaultProps = { onClose: () => {}, pastExpirationDate: false };

TryBuyPopupBase.propTypes = exact({
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  pastExpirationDate: PropTypes.bool,
});

export const TryBuyPopup = React.memo(TryBuyPopupBase);
TryBuyPopup.displayName = 'TryBuyPopup';
